const MAX_LOG_ENTRIES = 80;
const listeners = new Set();
let entries = [];

function notify() {
  listeners.forEach((listener) => listener(entries));
}

function normalizeDetails(details) {
  if (!details || typeof details !== 'object') return {};

  return Object.fromEntries(
    Object.entries(details)
      .filter(([, value]) => typeof value !== 'undefined' && value !== null && value !== '')
      .map(([key, value]) => [key, typeof value === 'object' ? JSON.stringify(value) : String(value)])
  );
}

export function addSystemLog({ type = 'info', message, details = {} }) {
  const entry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    type,
    message: String(message || 'Evento do sistema'),
    details: normalizeDetails(details),
    at: new Date().toISOString()
  };

  entries = [entry, ...entries].slice(0, MAX_LOG_ENTRIES);
  notify();
  return entry;
}

export function clearSystemLog() {
  entries = [];
  notify();
}

export function getSystemLogEntries() {
  return entries;
}

export function subscribeSystemLog(listener) {
  listeners.add(listener);
  listener(entries);

  return () => {
    listeners.delete(listener);
  };
}
